export default {
  path: '/selected-course/list',
  component: function component() {
    return import('@/views/selectedCourse/index');
  },
  name: 'SelectedCourseList',
  meta: {
    title: '线上课程'
  }
};